export type FormattedFilterGroup = {
  id: string;
  label: string;
  key: string;
  title: string;
  values: FormattedFilter[];
};

export interface DepictMeta2 {
  group_title: string;
  type: string;
  values: string[];
  counts: number[];
  names: string[];
  swatches?: string[];
}

export interface FormattedFilter {
  name: string;
  value: string;
  count: number;
  hex?: string;
}

export type FilterValue = string[] | string;

export interface FilterMeta {
  group_title: string;
  type: string;
  values: FilterValue[];
  counts: number[];
  names: string[];
}

export interface DepictFilter {
  field: string;
  op: string;
  meta: DepictMeta2;
  id: string;
}

const sortSizes = (arr: FormattedFilter[]) => {
  arr.sort((a, b) => {
    /*  if (isNumeric(a.value) && isNumeric(b.value)) {
      return Number(a.value) - Number(b.value);
    }
    if (isDashedSize(a.value) && !isDashedSize(b.value)) return 1;
    if (!isDashedSize(a.value) && isDashedSize(b.value)) return -1; */
    if (a.value === "ONESZ") return 1;
    if (b.value === "ONESZ") return -1;
    return 0;
  });
  return arr;
};

export const createFormattedFilters = (filters: DepictFilter[] | null) => {
  const filterGroups: FormattedFilterGroup[] = [];
  if (!filters) return filterGroups;

  for (const group of filters) {
    if (group?.meta?.type === "checkbox") {
      const checkboxGroup: FormattedFilterGroup = {
        title: group.meta.group_title ?? "",
        key: group.field ?? "",
        label: group.field ?? "",
        id: group.id ?? "",
        values: group.meta.values.map((value, i) => ({
          value,
          name: group?.meta?.names?.[i] ?? "",
          count: group?.meta?.counts?.[i] ?? 0,
        })),
      };

      filterGroups.push(checkboxGroup);
      continue;
    }

    // Handle regular filters
    const formattedGroup: FormattedFilterGroup = {
      title: group.meta.group_title,
      key: group.field,
      label: group.field,
      id: group.id,
      values: group.meta.values?.map((value, i) => {
        /* 		let hex;
				if (group.meta.group_title === "Colour" && typeof value === "string") {
					hex = value.split(";")[1];
				} */

        return {
          value: value,
          name: group.meta.names[i],
          count: group.meta.counts[i],
          hex: group.meta.swatches?.[i],
        };
      }) as FormattedFilter[],
    };

    if (
      group.field === "size_name" ||
      group.meta.group_title.toLowerCase().includes("size")
    ) {
      formattedGroup.values = sortSizes(formattedGroup.values);
    }

    filterGroups.push(formattedGroup);
  }

  return filterGroups;
};
